import { BLOCK_CLASSES as t } from "../../constants.js";
import { defineAttrs as r } from "../../utils/typed-attrs.js";
import { stylable as o } from "../decorators/stylable.js";
const e = r({
  type: { default: "horizontalRule" },
  width: { default: "" }
}), d = o({
  content: "",
  group: "block",
  attrs: e,
  parseDOM: [
    {
      tag: "hr"
    }
  ],
  toDOM(i) {
    return [
      "div",
      {
        class: `${t.divider} intercom-divider-container`
      },
      ["div", ["hr"]]
    ];
  }
});
export {
  d as horizontalRuleSpec
};
